import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  template: require('./modal-confirm-leave.component.pug'),
  // styles: [require('./modal-add-inbox.component.css').toString()],
})
export class ModalConfirmLeaveComponent {
  @Input()
  prompt: string;

  @Output()
  onClose = new EventEmitter<boolean>();

  // -------------------------------------------------------------------
  constructor(public bsModalRef: BsModalRef) {}

  onConfirm() {
    this.onClose.emit(true);
    this.bsModalRef.hide();
  }

  onCancel() {
    this.onClose.emit(false);
    this.bsModalRef.hide();
  }
}
